import { Box, CircularProgress } from '@mui/material';
import { Stream } from '@cloudflare/stream-react';
import useBoolean from 'hooks/useBoolean';

const VideoPlayer = ({
    videoId = '8ce3330ff22c33d178270ec0b36d8987',
    controls = true,
    autoplay = false,
    muted = false,
    frame = true,
    aspect = '16/9',
}) => {
    const loading = useBoolean(true);

    return (
        <Box
            sx={{
                borderRadius: 2,
                overflow: 'hidden',
                bgcolor: frame ? 'background.paper' : 'transparent',
                boxShadow: frame ? 3 : 0,
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: 1,
                    aspectRatio: aspect,
                }}
            >
                <Box sx={{ position: 'absolute', inset: 0 }}>
                    <Stream
                        src={videoId}
                        controls={controls}
                        autoPlay={autoplay}
                        muted={muted}
                        height="100%"
                        width="100%"
                        onCanPlay={() => loading.onFalse()}
                    />

                    {loading.value && (
                        <Box
                            sx={{
                                position: 'absolute',
                                inset: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'rgba(0, 0, 0, 0.5)',
                            }}
                        >
                            {loading.value && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        inset: 0,
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        bgcolor: 'rgba(255,255,255,0.6)',
                                        pointerEvents: 'none',
                                    }}
                                >
                                    <CircularProgress />
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default VideoPlayer;
